export default function smoothscroll() {

  // PCデバイス
  var pcSwitch = window.matchMedia('(min-width: 769px)').matches;
  // SPデバイス
  var spSwitch = window.matchMedia('(max-width: 768px)').matches;
  // Smooth Scroll
  var smoothScroll = $('a[href^="#"].js-smoothScroll');
  // アンカーターゲット
  var anchorTarget = $('.js-anchor');
  // Headerの高さ取得
  var headerHeight = $('header').outerHeight();
  // スクロールの速度
  var speed = 400;

  /* SP版 別ページから遷移時、アンカーリンクの位置調整(遷移先のIDにクラス付与)
  ----------------------------------------------------------------- */
  if (spSwitch) {
    setTimeout(function () {
      anchorTarget.addClass('c-anchor__link');
    }, 1000);
  }

  /* PC版 別ページから遷移時、アンカーリンクの位置調整
  ----------------------------------------------------------------- */
  if (pcSwitch) {
    // URL取得
    var url = $(location).attr('href');

    if (url.indexOf("#") != -1) {
      var anchor = url.split("#");
      var target = $('#' + anchor[anchor.length - 1]);

      if (target.length) {
        var anchorPos = Math.floor(target.offset().top) - headerHeight;
        $('html, body').scrollTop(anchorPos);
      }
    }
  }

  /* Smooth Scroll処理
  ----------------------------------------------------------------- */
  smoothScroll.on('click', function (e) {
    // アンカーの値取得
    var href = $(this).attr("href");
    // 移動先を取得
    var target = $(href);
    // 移動先を数値で取得
    var headerPos = target.offset().top - headerHeight;

    e.preventDefault();

    $('body,html').animate({
      scrollTop: headerPos
    }, speed, 'swing');
    return false;
  });

}